(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-carousel-image"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
	const carousels = document.querySelectorAll('.custom-carousel-image-wrapper');

	carousels.forEach(carouselWrapper => {
		const dots = carouselWrapper.parentElement.querySelectorAll('.dot');
		const totalImages = parseInt(carouselWrapper.getAttribute('data-total-images'), 10);
		let currentIndex = 0;

		const imageWidth = carouselWrapper.querySelector('.custom-carousel-image img').offsetWidth;

		function scrollToIndex(index) {
			const scrollOffset = window.innerWidth <= 768 ? 16 : -32;
			const scrollAmount = index * imageWidth + scrollOffset;
			carouselWrapper.scrollTo({
				left: scrollAmount,
				behavior: 'smooth'
			});
			updateDots(index);
		}

		function updateDots(index) {
			dots.forEach((dot, i) => {
				dot.classList.toggle('active', i === index);
			});
		}

		let autoScroll = setInterval(() => {
			currentIndex = (currentIndex + 1) % totalImages;
			scrollToIndex(currentIndex);
		}, 5000);

		dots.forEach((dot, index) => {
			dot.addEventListener('click', () => {
				currentIndex = index;
				scrollToIndex(currentIndex);
				clearInterval(autoScroll);
			});
		});

		carouselWrapper.addEventListener('scroll', () => {
			const scrollLeft = carouselWrapper.scrollLeft;
			const newIndex = Math.round(scrollLeft / imageWidth);
			if (newIndex !== currentIndex) {
				currentIndex = newIndex;
				updateDots(currentIndex);
			}
		});

		carouselWrapper.addEventListener('mouseover', () => {
			clearInterval(autoScroll);
		});

		carouselWrapper.addEventListener('mouseout', () => {
			autoScroll = setInterval(() => {
				currentIndex = (currentIndex + 1) % totalImages;
				scrollToIndex(currentIndex);
			}, 5000);
		});
	});
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-cta-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const ctaSections = document.querySelectorAll('.custom-cta-section-image');
    ctaSections.forEach(function(ctaSection) {
      ctaSection.addEventListener('click', function(event) {
        event.stopPropagation();
        const url = ctaSection.getAttribute('cta-url')
        if(url){
          window.open(url, '_blank');
        }
      })
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-promo"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const promoCards = document.querySelectorAll('.promo-card');
    promoCards.forEach(function(card) {
    var promoUrl = card.getAttribute('promo-url');
    if (promoUrl) {
      card.style.cursor = 'pointer';
    }
  });
    promoCards.forEach(function(promoCard) {
      promoCard.addEventListener('click', function(event) {
        const clickedElement = event.target;
        event.stopPropagation();
        if (clickedElement.closest('.promo-card') && clickedElement) {
          const promoUrl = promoCard.getAttribute('promo-url');
          if (promoUrl) {
            window.open(promoUrl, '_blank');
          }
        }
      });
    });
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-store-info"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const serviceCards = document.querySelectorAll('.custom-info-service-card');
  serviceCards.forEach(function(serviceCard) {
    serviceCard.addEventListener('click', function(event) {
      event.stopPropagation();
      const url = serviceCard.getAttribute('redirect-url')
      if(url){
        window.location.href = url;
      }
    })
  })
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-store-location"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const searchBar = document.getElementById('search-bar');
  const clearBtn = document.getElementById('clear-btn');
  const dropdown = document.getElementById('dropdown');
  const container = document.getElementById('store-container');
  const addressImgTemplate = document.getElementById('address-img-template').innerHTML;
  const storeImgTemplate = document.getElementById('store-img-template').innerHTML;
  let storesData = {};
  let allStoreData = {}
  let dropdownData = [];
  getStoreLocations("",true)

  async function getStoreLocations(searchQuery = "",setStoresData = false) {
    try {
      const response = await fetch(`https://${env}/hello-gateway/hello-api/api/location/getLocations?searchQuery=${encodeURIComponent(searchQuery)}`,
        {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Hmac-Sha256": "EPP",
          "X-Shopify-Shop-Domain": Shopify.shop.toString(),
        },
        body: JSON.stringify({})
      });
      if (response.status === 200) {
        const apiResponse = await response.json();
        storesData = apiResponse.value.locationResponseMap || {};
        dropdownData = []
        const cities = Object.keys(storesData);
        cities.forEach(city => {
          dropdownData.push({ name: city, isCity: true });
          const stores = storesData[city];
          stores.forEach(store => {
            dropdownData.push({
              name: store.name,
              isCity: false,
              address: store.address2,
              storeUrl: '/pages/' + store.name.toLowerCase().replace(/\s+/g, '-')
            });
          });
        });
        createDropdownItems();
        if(setStoresData){
          allStoreData = apiResponse.value.locationResponseMap;
          createStoreCards();
        }
      } else {
        allStoreData ={}
        storesData = {}
        dropdownData = []
      }
    } catch (error) {
      console.error('Error fetching store locations:', error);
    }
  }

  function createDropdownItems() {
    const dropdownContainer = document.getElementById('dropdown');
    dropdownContainer.innerHTML = '';
    dropdownData.sort((a, b) => a.isCity === b.isCity ? 0 : (a.isCity ? -1 : 1));
    if (dropdownData.length === 0) {
      const div = document.createElement('div');
      div.classList.add('dropdown-no-item');
      div.innerHTML = '<div class="dropdown-item-no-dropdownData">Lokasi tidak ditemukan. Silakan dicoba lagi, ya.</div>';
      dropdownContainer.appendChild(div);
      return;
    }

    dropdownData.forEach((item, index) => {
      const div = document.createElement('div');
      div.classList.add('dropdown-item');
      if (item.isCity) {
        div.setAttribute('city-name', item.name);
        div.innerHTML = addressImgTemplate + `<div class="dropdown-item-name">${item.name}</div>`;
      } else {
        div.innerHTML = storeImgTemplate + `
          <a class="dropdown-item-link" href="${item.storeUrl}">
            <div class="dropdown-item-detail">
              <div class="dropdown-item-name">${item.name}</div>
              <div class="dropdown-item-address">${item.address}</div>
            </div>
          </a>
        `;
      }
      dropdownContainer.appendChild(div);
      if (index !== dropdownData.length - 1) {
        const divider = document.createElement('div');
        divider.classList.add('custom-divider');
        dropdownContainer.appendChild(divider);
      }
    });
  }

  function createStoreCards() {
    container.innerHTML = '';
    Object.keys(allStoreData).forEach(city => {
      const cityDiv = document.createElement('div');
      cityDiv.className = 'location-wrapper';

      const cityName = document.createElement('div');
      cityName.className = 'store-city-name';
      cityName.innerText = city;
      cityDiv.appendChild(cityName);

      const storeWrapper = document.createElement('div');
      storeWrapper.className = 'store-card-wrapper';

      allStoreData[city].forEach(store => {
        const storeCard = document.createElement('div');
        storeCard.setAttribute('store-name', store.name);
        storeCard.className = 'store-card';

        const storeName = document.createElement('div');
        storeName.className = 'store-card-name';
        storeName.innerText = store.name;
        storeCard.appendChild(storeName);

        const storeLocation = document.createElement('div');
        storeLocation.className = 'store-card-location';
        storeLocation.innerText = store.metaFields.floor_no || 'Lantai -';
        if(store.metaFields.floor_no){
          storeCard.appendChild(storeLocation);
        }

        const storeAddress = document.createElement('div');
        storeAddress.className = 'store-card-address';

        const addressImg = document.createElement('div');
        addressImg.className = 'store-card-address-img';
        addressImg.innerHTML = addressImgTemplate;
        storeAddress.appendChild(addressImg);

        const addressText = document.createElement('div');
        addressText.setAttribute('mapUrl', store.metaFields.location_map_link);
        addressText.className = 'store-card-address-text';
        addressText.innerText = store.address2;
        storeAddress.appendChild(addressText);

        storeCard.appendChild(storeAddress);
        storeWrapper.appendChild(storeCard);
      });

      cityDiv.appendChild(storeWrapper);
      container.appendChild(cityDiv);
    });
    initializeStoreClickEvent()
  }

  searchBar.addEventListener('input', debounce(function(event) {
    clearBtn.style.display = searchBar.value ? 'block' : 'none';
    dropdown.style.display = searchBar.value ? 'block' : 'none';
    const refreshStoreCard = searchBar.value ? false : true
    getStoreLocations(searchBar.value, refreshStoreCard);
  }, 300));

  clearBtn.addEventListener('click', function() {
    searchBar.value = '';
    clearBtn.style.display = 'none';
    dropdown.style.display = 'none';
    searchBar.focus();
    getStoreLocations('',true)
  });

  document.addEventListener('click', function(event) {
    if (!searchBar.contains(event.target) && !dropdown.contains(event.target)) {
      dropdown.style.display = 'none';
    }
  });

  searchBar.addEventListener('focus', function() {
    if (searchBar.value) {
      dropdown.style.display = 'block';
    }
  });

  dropdown.addEventListener('click', function(event) {
    const dropdownItem = event.target.closest('.dropdown-item');
    if (dropdownItem) {
      const cityName = dropdownItem.getAttribute('city-name');
      if (cityName) {
        searchBar.value = cityName;
        getStoreLocations(cityName,true);
        dropdown.style.display = 'none';
      }
    }
  });

  function initializeStoreClickEvent() {
    const storeCards = document.querySelectorAll('.store-card');
    storeCards.forEach(function(storeCard) {
      storeCard.addEventListener('click', function(event) {
        const clickedElement = event.target;
        const addressTextElement = storeCard.querySelector('.store-card-address-text');
        event.stopPropagation();
        if (clickedElement === addressTextElement) {
          const mapUrl = addressTextElement.getAttribute('mapUrl');
          if (mapUrl) {
            window.open(mapUrl, '_blank');
          }
        } else if (clickedElement.closest('.store-card') && clickedElement !== addressTextElement) {
          const storeName = storeCard.getAttribute('store-name');
          if (storeName) {
            window.location.href = '/pages/' + storeName.toLowerCase().replace(/\s+/g, '-');
          }
        }
      });
    });
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-title"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const backButton = document?.getElementById('back-button');
  if(backButton){
    backButton.addEventListener('click', function() {
      window.history.back();
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
